module.exports = __webpack_public_path__ + "img/icon-check.1b2fbd68.svg";